<app-header class="global-header-class"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
